import { useState } from 'react';
import { api, GalatApi, GalatJaringan } from '../lib/api';
import { useSesi } from '../state';
import { rupiah } from '@santap/shared';

/**
 * Buka shift.
 *
 * Kas awal dicatat karena tanpanya tutup buku tidak punya titik mula, dan
 * selisih kas jadi tidak bisa dijelaskan. Ini satu-satunya titik di alur
 * kasir yang memang butuh server — sesudahnya, semua bisa offline.
 */
export function BukaShift() {
  const { sesi, simpanSesi } = useSesi();
  const [kas, setKas] = useState(0);
  const [galat, setGalat] = useState<string | null>(null);
  const [sibuk, setSibuk] = useState(false);

  if (!sesi) return null;

  const cepat = [0, 200_000, 500_000, 1_000_000];

  async function buka() {
    setGalat(null);
    setSibuk(true);
    try {
      const s = await api.bukaShift(sesi!.outletId, sesi!.terminalId, kas);
      await simpanSesi({ ...sesi!, shiftId: s.id });
    } catch (err) {
      if (err instanceof GalatApi && err.kode === 'shift_sudah_buka') {
        // Tablet di-restart di tengah shift. Lanjutkan yang sudah ada, jangan
        // paksa kasir menutup shift yang masih berjalan.
        const id = (err.detail as any)?.shiftId;
        if (id) { await simpanSesi({ ...sesi!, shiftId: id }); return; }
        setGalat(err.message);
      } else if (err instanceof GalatJaringan) {
        setGalat('Tidak bisa menghubungi server. Membuka shift butuh internet — setelah terbuka, kasir bisa bekerja offline.');
      } else if (err instanceof GalatApi) {
        setGalat(err.message);
      } else {
        setGalat('Terjadi kesalahan tak terduga.');
      }
    } finally {
      setSibuk(false);
    }
  }

  return (
    <div className="tengah">
      <div className="kartu">
        <h1>Buka shift</h1>
        <p className="ket">
          {sesi.outletNama} · {sesi.pengguna.nama}
        </p>

        {galat && <div className="galat">{galat}</div>}

        <div className="isian">
          <label htmlFor="kas">Kas awal di laci</label>
          <input id="kas" inputMode="numeric" value={kas === 0 ? '' : String(kas)}
                 placeholder="0"
                 onChange={(e) => setKas(Number(e.target.value.replace(/\D/g, '')) || 0)} />
        </div>

        <div className="cepat" style={{ marginBottom: 16 }}>
          {cepat.map((v) => (
            <button key={v} type="button" onClick={() => setKas(v)}
                    className={kas === v ? 'pas' : ''}>
              {v === 0 ? 'Kosong' : rupiah(v)}
            </button>
          ))}
        </div>

        <button className="tbl utama lebar" onClick={buka} disabled={sibuk}>
          {sibuk ? 'Membuka…' : `Buka shift dengan ${rupiah(kas)}`}
        </button>
      </div>
    </div>
  );
}
